<template>
  <div>
    <b-card title="🚀 به نرم افزار حضور و غیاب تیک خوش آمدید ">
      <b-card-text>برای ثبت ورود و خروج وارد قسمت ثبت تردد شوید.</b-card-text>
        <b-row align-v="center">
          <b-button
              variant="success"
              style="margin: 0 auto;"
              @click="addClick()"
          >ثبت تردد
          </b-button>
        </b-row>
    </b-card>
  </div>
</template>

<script>
import {
 BCard, BCardText, BLink, BButton, BRow
} from 'bootstrap-vue'
import router from '@/router'
import Config from '@/../config'

export default {
  components: {
    BCard,
    BCardText,
    // eslint-disable-next-line vue/no-unused-components
    BLink,
    BButton,
    BRow,
  },
  mounted() {
    if (Config.isAppEmployee) {
      this.$router.push({ name: 'tick-map' }).catch(() => {})
    } else {
      this.$router.push({ name: 'dashboard' }).catch(() => {})
    }
  },
  methods: {
    addClick() {
      router.push({ path: '/tick/map' })
    },
  },
}
</script>

<style>

</style>
